import { useController } from 'react-hook-form';

import { Button, Flex, Stack, Text } from '@mantine/core';

import { ComponentType } from 'models';

import { NonDcideComponent } from 'components/forms/fields/compatible-with/components/AddNonDcideComponentForm';
import { ComponentThumbnail } from 'components/thumbnail/ComponentThumbnail';

const CompatibleWithPlaceholders = () => {
    const {
        field: { value: placeholders = [], onChange },
    } = useController({ name: 'compatibleWithPlaceholders' });

    if (!placeholders.length) {
        return null;
    }

    const onRemove = ({ manufacturer, productIdentifier }: NonDcideComponent) => {
        onChange(
            placeholders.filter(
                (savedManufacturer: NonDcideComponent) =>
                    savedManufacturer.manufacturer !== manufacturer &&
                    savedManufacturer.productIdentifier !== productIdentifier,
            ),
        );
    };

    return placeholders.map(({ manufacturer, productIdentifier, componentType }: NonDcideComponent) => (
        <CompatiblePlaceholder
            key={`${manufacturer}-${productIdentifier}`}
            manufacturerName={manufacturer}
            productIdentifier={productIdentifier}
            componentType={componentType}
            onRemove={() => onRemove({ manufacturer, productIdentifier })}
        />
    ));
};

const CompatiblePlaceholder = ({
    manufacturerName,
    productIdentifier,
    componentType,
    onRemove,
}: {
    manufacturerName: string;
    productIdentifier: string;
    componentType?: ComponentType;
    onRemove?: () => void;
}) => {
    return (
        <Flex gap={8} w="100%" align="center">
            {componentType && (
                <ComponentThumbnail
                    showEmpty
                    component={{ images: [], type: componentType }}
                    style={{ width: 40, padding: 2, border: '1px solid var(--mantine-color-gray-2)', flex: 'auto 0 0' }}
                />
            )}

            <Stack gap={0}>
                <Text fz="xs">{productIdentifier}</Text>

                <Text fz="xs" c="dimmed">
                    {manufacturerName}
                </Text>
            </Stack>

            {onRemove && (
                <Button size="compact-xs" variant="light" ml="auto" onClick={onRemove}>
                    Remove
                </Button>
            )}
        </Flex>
    );
};

export { CompatibleWithPlaceholders, CompatiblePlaceholder };
